import React from "react"

import FormatMessage from "@irati/utils/lang"
import {H6} from "@irati/ui/src/Typography"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import Button from "@irati/ui/src/Button"
import {Invoice} from "@irati/types"

import {Label} from "./styled"

const columns = (
  formatMessage: FormatMessage,
  handleInvoiceDownload: (invoiceId: string) => void,
  downloadLoad: Promise<void>|null,
  invoiceId: string) => [
  {
    Header: <Label large>{formatMessage({id: "admin.billing.columns.invoiceNumber"})}</Label>,
    id: "invoiceNumber",
    minWidth: 150,
    style: {alignSelf: "center", border: "none"},
    accessor: (invoice: Invoice) => <H6>{invoice.invoiceNumber}</H6>
  },
  {
    Header: <Label large>{formatMessage({id: "admin.billing.columns.type"})}</Label>,
    id: "invoiceType",
    minWidth: 150,
    style: {alignSelf: "center", border: "none"},
    accessor: (invoice: Invoice) => <H6>{invoice.type}</H6>
  },
  {
    Header: <Label large>{formatMessage({id: "admin.billing.columns.dueDate"})}</Label>,
    id: "invoiceDueDate",
    minWidth: 150,
    style: {alignSelf: "center", border: "none"},
    accessor: (invoice: Invoice) => <H6>{invoice.dueDate}</H6>
  },
  {
    Header: <Label large>{formatMessage({id: "admin.billing.columns.invoiceDate"})}</Label>,
    id: "invoiceDate",
    minWidth: 150,
    style: {alignSelf: "center", border: "none"},
    accessor: (invoice: Invoice) => <H6>{invoice.invoiceDate}</H6>
  },
  {
    Header: <Label large>{formatMessage({id: "admin.billing.columns.invoiceTotal"})}</Label>,
    id: "invoiceTotal",
    minWidth: 150,
    style: {alignSelf: "center", border: "none"},
    accessor: (invoice: Invoice) => <H6>{formatCurrency({currencyCode: invoice.currency, value: invoice.amount})}</H6>
  },
  {
    Header: <Label large>{formatMessage({id: "admin.billing.columns.actions"})}</Label>,
    id: "invoiceActions",
    minWidth: 150,
    style: {alignSelf: "center", border: "none"},
    accessor: (invoice: Invoice) =>
      <Button
        primary
        load={invoiceId === invoice.invoiceId && downloadLoad}
        onClick={() => handleInvoiceDownload(invoice.invoiceId)}>
        {formatMessage({id: "admin.billing.downloadButton"})}
      </Button>
  }
]

export default columns
